/**
 * @generated SignedSource<<47f939a09dffbd090c26080766e4315d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DealMerchandisingFormPage_artist$data = {
  readonly id: string;
  readonly " $fragmentType": "DealMerchandisingFormPage_artist";
};
export type DealMerchandisingFormPage_artist$key = {
  readonly " $data"?: DealMerchandisingFormPage_artist$data;
  readonly " $fragmentSpreads": FragmentRefs<"DealMerchandisingFormPage_artist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DealMerchandisingFormPage_artist",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};

(node as any).hash = "d629e51bcdc70980558600aecf0d55df";

export default node;
